module.exports = __webpack_public_path__ + "static/img/code.d95de80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.png
// module id = EF7e
// module chunks = 1